import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { Translation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { getImagePairs, userRetakeGameReset } from '../../store/actions';
import {
  getAuthState,
  getOnboardingState,
  getTenantState,
  getPreRegistrationState,
} from '../../store/selectors';
import gameGif from '../../ASUPhotos/icons/Me3_2ndEdition-128s.gif';
import frGameGif from '../../ASUPhotos/icons/ou-gif.gif';
import esGameGif from '../../ASUPhotos/icons/o-gif.gif';
import ProgressBar from '../utility/ProgressBar';
import LoginButton from '../utility/LoginButton';
import Loading from '../utility/Loading';
import { loginCopy } from '../../copy/loginCopy.json';
import RouteBack from '../utility/RouteBack';
import SchoolLogo from '../utility/SchoolLogo';
import { fireGTM } from '../../gtm/gtmUtil';
import { playNow_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import PoweredByASUBlackAndWhite from '../utility/PoweredByASUBlackAndWhite';
import WindowTitle from '../utility/WindowTitle';

const bars = {
  Onboarding: {
    current: 100,
    override: false,
  },
  'Picture Game': {
    current: 0,
    override: true,
  },
  'Career Path': {
    current: 0,
    override: false,
  },
};

const playButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    borderColor: props.tenant.primary,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
};

class GameLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retry: false,
    };
  }

  componentDidMount() {
    this.props.getImagePairs(this.props.tenant.id);
    const modeParam = new URLSearchParams(this.props.location.search);
    const retry = modeParam.get('retry');
    this.setState({
      retry,
    });
  }

  secondaryBorder = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  largeSecondaryBorder = {
    borderTop: `11px solid ${this.props.tenant.secondary}`,
  };

  handlePlayNowClicked = async () => {
    const { retry } = this.state;
    fireGTM(playNow_GTM, 'play now', "let's build your career profile!");
    if (retry) {
      this.props.history.push('game?retry=true');
    } else {
      this.props.history.push('game');
    }
  };

  render() {
    if (this.props.images.length === 0) {
      return <Loading height="100vh" />;
    }

    let gameGifSrc = gameGif;
    const locale = localStorage.getItem('ME3_PERSISTENCE_LOCALE');
    if (locale === 'es') {
      gameGifSrc = esGameGif;
    } else if (locale === 'fr') {
      gameGifSrc = frGameGif;
    }

    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Picture Game')}</WindowTitle>
            <div id="game-landing" style={this.largeSecondaryBorder}>
              <div className="top-container">
                <div className="utility-container">
                  <RouteBack
                    color={this.props.tenant.primary}
                    route="/terms-and-conditions"
                    tenant={this.props.tenant}
                    section="let's build your career profile!"
                    text="back"
                  />
                  <LoginButton
                    color={this.props.tenant.primary}
                    isAuthenticated={this.props.isAuthenticated}
                    tenant={this.props.tenant}
                  />
                </div>
                <div className="logo-text-container">
                  <SchoolLogo
                    schoolLogoWidth="100%"
                    horizontalAlign="flex-start"
                    containerMargin="20px 0 20px 0"
                    schoolLogoContainerMinWidth="0"
                  />
                  <div className="header-text-container">
                    <h1>{t(`Let's build your career profile!`)}</h1>
                    <div className="fake-border" style={this.secondaryBorder} />
                  </div>
                  {/* Need this to center the header text */}
                  <div className="column is-one-quarter asu-logo-container-game-dummy" />
                </div>
              </div>
              <div className="game-intro-container">
                {/* eslint-disable */}
                <img
                  className="game-gif"
                  data-cy="game-gif"
                  onClick={() => this.handlePlayNowClicked()}
                  src={gameGifSrc}
                  alt={t('gif of gameplay')}
                />
                {/* eslint-enable */}
                <div className="game-intro-text">
                  <p>
                    {t(
                      'Look at the images and pick which one is most appealing to you.'
                    )}
                  </p>
                  <p>{t('Go with your first instinct.')}</p>
                </div>
                <button
                  data-cy="game-play-now"
                  className={[
                    'button--primary',
                    this.props.classes.color,
                    'play-now',
                  ].join(' ')}
                  type="button"
                  onClick={() => this.handlePlayNowClicked()}
                >
                  {t('Play now')}
                </button>
              </div>
              <div className="game-landing-progress">
                <ProgressBar
                  bars={bars}
                  currentPhase={0}
                  tenant={this.props.tenant}
                />
              </div>
              <PoweredByASUBlackAndWhite tenant={this.props.tenant} />
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const isAuthenticated = state.auth.isAuthenticated;
  const images = getPreRegistrationState(state).imagePairs;
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const tenant = getTenantState(state);

  return { isAuthenticated, images, auth, onboarding };
};

const GameLandingConnected = withRouter(
  connect(mapStateToProps, {
    getImagePairs,
    userRetakeGameReset,
  })(GameLanding)
);

GameLanding.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default withStyles(playButtonStyles)(GameLandingConnected);
